<template>
  <div class="reco-list container mt-5">
    <h2 class="headline my-1" align="center">이런 글은 어떠세요?</h2>
    <v-container fluid v-if="contents.length">
      <v-row>
        <v-col v-for="content in contents" :key="content.id" sm="12" md="4">
          <v-card hover @click="gotoView(content.id)">
            <v-img
              :src="content.img" class="white--text align-end" height="200px">
            </v-img>
            <v-card-actions>
              <span class="ml-3">{{ content.title }}</span>
              <v-spacer></v-spacer>
              <span class="likes">
                <span>{{ content.likes }}</span>
                <v-icon small right color="pink">mdi-heart-outline</v-icon>
              </span>         
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div v-else>
      <Progress class="mt-5" />
    </div> 
  </div>
</template>

<script>
import db from '@/firebase/init'
import Progress from '@/components/layouts/Progress'

export default {
  name: 'recolist',
  components: { Progress },
  data() {
    return {
      contents: [],
    }
  },
  methods: {
    gotoView(id) {
      this.$router.push({ name: 'content', params: { id: id } })
    }
  },
  created() {
    db.collection('contents').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let content = doc.data()
          content.id = doc.id
          if(content.img) {
           this.contents.push(content)
          }
        })
      })
  }
}
</script>

<style>

</style>